import React from "react";
import { Progress } from "antd";

interface CustomProgressProps {
  current: number;
  total: number;
  type?: string;
}

const CustomProgress: React.FC<CustomProgressProps> = ({ current, total, type }) => {
  const percent = total > 0 ? (current / total) * 100 : 0;

//   const hue = 200 - (200 * percent) / 100;

//   const gradient = `
//     linear-gradient(
//       to right,
//       hsla(${hue}, 85%, 65%, 1),
//       hsla(${hue + 30}, 90%, 55%, 0.95)
//     )
//   `;
  // Nếu đạt 100% -> chỉ 1 màu xanh
  const strokeColor =
    percent === 100
      ? "#31A168"
      : "#F5B40B";



  return (
    <div className="flex items-center gap-3 w-full">
      <Progress
        percent={percent}
        showInfo={false}
        strokeColor={strokeColor}
        className="flex-1 custom-progress"
      />

      {/* Hiển thị dạng: 2/3 CONT */}
      <span className="text-sm font-medium text-gray-700">
        {current}/{total} {type}
      </span>
    </div>
  );
};

export default CustomProgress;
